import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const BorrarRutaParte = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.del(`/rutas_partes/${params}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        borrarRutaParteMutation: mutation.mutate,
    };
}